// Centralized app z-index values to keep layering behavior predictable.
// If MUI's modal z-index is ever customized, update this base and the related values.
// 1300 matches MUI's default theme.zIndex.modal baseline.
const MUI_MODAL_BASE_Z_INDEX = 1300;

export const APP_Z_INDEX = {
  // Drawer should stay above standard MUI modals/table fullscreen overlays.
  drawer: MUI_MODAL_BASE_Z_INDEX + 1,
  // Dialogs opened from within a drawer must sit above the drawer.
  drawerDialog: MUI_MODAL_BASE_Z_INDEX + 2,
  // Autocomplete popper should stay above drawer so dropdown options are visible.
  autocompletePopper: MUI_MODAL_BASE_Z_INDEX + 3,
} as const;
